var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: { "has-line": "", title: "Documento de Enmienda" }
      }),
      !_vm.documents.length && !_vm.isAdding
        ? _c("div", { staticClass: "bg-secondary-3 p-3 mt-3 rounded" }, [
            _c("div", [
              _c("div", { staticClass: "upload-file-button__container" }, [
                _c("div", { staticClass: "panel-row-without-selector p-4" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn bg-light-white col-12 col-md-4",
                        on: {
                          click: function($event) {
                            _vm.isAdding = true
                          }
                        }
                      },
                      [
                        _c("em", {
                          staticClass: "fas fa-file-plus pr-4 text-green"
                        }),
                        _c(
                          "span",
                          { staticClass: "text-button-add-document" },
                          [_vm._v(" Presione aquí para anejar documento ")]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _c(
            "div",
            _vm._l(_vm.documents, function(document) {
              return _c("amendment-document-row", {
                key: document.documentId,
                attrs: {
                  document: document,
                  "has-delete-permission": _vm.hasDeleteDocumentPermission
                },
                on: {
                  "on-download": _vm.onDownload,
                  "on-remove": _vm.onRemoveDocuments
                }
              })
            }),
            1
          ),
      _vm.isAdding
        ? _c(
            "div",
            { staticClass: "bg-secondary-3 p-3 mt-3 rounded" },
            [
              _c(
                "validation-observer",
                {
                  ref: "documentObserver",
                  staticClass: "row mx-2",
                  attrs: { tag: "div" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-4 col-sm-6" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      id: "ddlDocumentType",
                                      "custom-error-msg":
                                        "Favor seleccionar tipo de documento.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Tipo de Documento",
                                      options: _vm.documentTypes
                                    },
                                    model: {
                                      value: _vm.model.documentType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "documentType", $$v)
                                      },
                                      expression: "model.documentType"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1488529319
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 col-sm-6",
                      class: _vm.model.file && "d-flex justify-content-center"
                    },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-file-input", {
                                    ref: "fileUpload",
                                    staticClass: "mt-4 pt-1",
                                    attrs: {
                                      accept: _vm.allowedFiles,
                                      "custom-error-msg":
                                        "Favor seleccionar un documento.",
                                      "display-style": "normal",
                                      error: errors[0],
                                      label: "",
                                      "label-position": "left",
                                      "on-download": () => {},
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.model.file,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "file", $$v)
                                      },
                                      expression: "model.file"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          711013104
                        )
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "mt-4 text-right" },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              id: "btnCancel",
                              i: "fas fa-times-circle",
                              variant: "outline-danger btn-cancel danger m-2"
                            },
                            on: { click: _vm.closeAdding }
                          },
                          [_vm._v(" Cancelar ")]
                        ),
                        _c(
                          "action-button",
                          {
                            attrs: {
                              id: "btnAdd",
                              i: "fas fa-file-plus",
                              variant: "success pl-4 pr-4"
                            },
                            on: { click: _vm.onAdd }
                          },
                          [_vm._v(" Añadir ")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.documents.length > 0 && !_vm.isAdding
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end mt-3" },
            [
              _vm.hasAddDocumentPermission
                ? _c(
                    "action-button",
                    {
                      attrs: { i: "fas fa-file-plus", variant: "success" },
                      on: {
                        click: function($event) {
                          _vm.isAdding = true
                        }
                      }
                    },
                    [_vm._v(" Añadir ")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }